var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7519 6.46664C12.4959 4.95731 11.1839 3.79998 9.59987 3.79998C7.83454 3.79998 6.39987 5.23464 6.39987 6.99998C6.39987 8.76531 7.83454 10.2 9.59987 10.2C11.1839 10.2 12.4959 9.04264 12.7519 7.53331H15.4665V6.46664H12.7519ZM9.59987 9.13331C8.4212 9.13331 7.46654 8.17864 7.46654 6.99998C7.46654 5.82131 8.4212 4.86664 9.59987 4.86664C10.7785 4.86664 11.7332 5.82131 11.7332 6.99998C11.7332 8.17864 10.7785 9.13331 9.59987 9.13331ZM9.59987 12.3333V13.4C6.25054 13.4 3.49854 10.8133 3.22654 7.53331H0.533203V6.46664H3.22654C3.49854 3.18664 6.25054 0.599976 9.59987 0.599976V1.66664C6.6612 1.66664 4.26654 4.06131 4.26654 6.99998C4.26654 9.93864 6.6612 12.3333 9.59987 12.3333Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppService);
export default __webpack_public_path__ + "static/media/app_service.c5d47df30fc3520409d941ea41bbbf57.svg";
export { ForwardRef as ReactComponent };